// tgBackButton — Alpine data component that exposes the Telegram WebApp's
// native back arrow on whichever element binds it via x-data. When the element
// teardowns (e.g. htmx swaps the page away), the back button is hidden again.
//
// No-ops cleanly when running outside the Telegram client (e.g. plain Chrome
// pointed at the ngrok URL for debugging) since Telegram.WebApp is undefined.
document.addEventListener('alpine:init', () => {
	Alpine.data('tgBackButton', (target) => ({
		handler: null,
		init() {
			const tg = window.Telegram?.WebApp?.BackButton;
			if (!tg) return;
			this.handler = () => { window.location.href = target; };
			tg.onClick(this.handler);
			tg.show();
		},
		destroy() {
			const tg = window.Telegram?.WebApp?.BackButton;
			if (!tg || !this.handler) return;
			tg.offClick(this.handler);
			tg.hide();
		},
	}));
});
